// Start Gift Icon
$(document).ready(function() {
  
  setTimeout(
  function() 
  {

if($(window).width() < 988) {
             
$("#menu-drawer > div > div > nav > ul > li:nth-child(1) > a > span.gm-icon.gm-icon-img").html("<img src='https://cdn.shopify.com/s/files/1/0855/3804/6232/files/vtb-20230112-vday-hearts.gif?v=1736889279'>");  
              
 } else if ($(window).width() >= 988) {
  
$("div > header > nav > ul > li:nth-child(1) > a > span.gm-icon.gm-icon-img").html("<img src='https://cdn.shopify.com/s/files/1/0855/3804/6232/files/vtb-20230112-vday-hearts.gif?v=1736889279'>");  
     
  
                                        
    };

     }, 1000);
  });
// End Gift Icon

